import { actionCreator } from '@ardoq/rxbeach';

export const requestOptionsDataFetch = actionCreator(
  '[PerspectiveEditorData] Request options data fetch'
);
